import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  login(body: any) {
    return this.httpClient.post(`${environment.baseUrl}/user/login`, body);
  }

  refreshLogin(refreshToken: string) {
    return this.httpClient.post(`${environment.baseUrl}/user/auto_login`, { refresh_token: refreshToken });
  }

}
